import styled from 'styled-components';

import { media } from '@ovpn-ui/styles';

export const Wrapper = styled.span`
    display: inline-flex;
    align-items: center;

    white-space: nowrap;

    a svg {
        color: inherit;
    }

    ${media.XS`
        display: initial;
        white-space: normal;

        a {
            display: inline;
        }

    `}
`;
